"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalTreeEditWarningFormInitialValues = exports.GlobalTreeEditWarningFormFieldNames = void 0;
exports.GlobalTreeEditWarningFormFieldNames = {
    isGlobalStrategyReplacementAccepted: 'isGlobalStrategyReplacementAccepted',
};
exports.globalTreeEditWarningFormInitialValues = {
    [exports.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted]: false,
};
